import { type AssetDropDestination, type ProcessAssetDropPayloadResult } from './canvasAssetDropTypes';
import { filterImageAssets } from './filterImageAssets';
import { getAssetDropToastMessage } from './getAssetDropToastMessage';
import { parseCanvasAssetPayload } from './parseCanvasAssetPayload';

/**
 * Parses raw drop payload, filters to canvas-eligible assets, shows toast, and returns result.
 * Shared by canvas and chat drop targets so parse/filter/toast logic lives in one place.
 */
export function processAssetDropPayload(
  rawPayload: string,
  destination: AssetDropDestination,
  showToast: (message: string) => void,
): ProcessAssetDropPayloadResult | null {
  let allAssets: ReturnType<typeof parseCanvasAssetPayload>;
  try {
    allAssets = parseCanvasAssetPayload(rawPayload);
  } catch {
    return null;
  }
  const { imageAssets, videoAssets, addedCount, unsupportedCount, videoRejections } = filterImageAssets(allAssets);
  const message = getAssetDropToastMessage(addedCount, unsupportedCount, destination, videoRejections);

  if (message) {
    showToast(message);
  }

  return { addedCount, imageAssets, unsupportedCount, videoAssets };
}
